import { useCurrency } from '../contexts/CurrencyContext'

interface CurrencyIconProps {
  className?: string
}

const CurrencyIcon = ({ className = "w-6 h-6" }: CurrencyIconProps) => {
  const { selectedCurrency } = useCurrency()
  
  return (
    <span className={`flex items-center justify-center font-bold ${className}`}>
      {selectedCurrency.symbol}
    </span>
  )
}

export default CurrencyIcon 